import mapValues from "lodash/mapValues";
import { connect } from "react-redux";
import Toolbar from "../components/Engineering/Toolbar";
import { openWorkArea, toggleGraphics } from "../actions/engineering";
import { STATUS_ON, STATUS_OFF, STATUS_LOADING } from "../constants/common";

const mapStateToProps = state => {
  const nodeStatus = mapValues(state.engineering.workAreas, wa => {
    return wa.loading ? STATUS_LOADING : wa.open ? STATUS_ON : STATUS_OFF;
  });

  return {
    title: "Engineering",
    config: state.engineering.toolbar,
    graphics: state.engineering.graphics,
    disabled: state.unity.loading,
    nodeStatus
  };
};

const mapDispatchToProps = dispatch => ({
  openWorkArea: node => dispatch(openWorkArea(node)),
  toggleGraphics: node => dispatch(toggleGraphics(node))
});

const EngineeringToolbar = connect(
  mapStateToProps,
  mapDispatchToProps
)(Toolbar);

export default EngineeringToolbar;
